export default __webpack_public_path__ + "img/BB_RTK.7232c39c2c217aa2dbbc641c1ffe7458.jpg";